import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import ToolCard from './components/ToolCard';
import ImageCompress from './tools/ImageCompress';
import ImageResize from './tools/ImageResize';
import ImageRotate from './tools/ImageRotate';
import ImageToJPG from './tools/ImageToJPG';
import ImageToPDF from './tools/ImageToPDF';
import PDFMerge from './tools/PDFMerge';
import PDFSplit from './tools/PDFSplit';
import PDFRotate from './tools/PDFRotate';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import About from './pages/About';
import Contact from './pages/Contact';

function HomePage() {
  const [currentTool, setCurrentTool] = useState(null);

  const tools = [
    {
      category: 'Image Tools',
      items: [
        {
          id: 'image-compress',
          icon: '📦',
          title: 'Image Compress',
          description: 'Compress images online, reduce file size',
          gradient: 'gradient-purple',
          component: ImageCompress
        },
        {
          id: 'image-resize',
          icon: '📐',
          title: 'Image Resize',
          description: 'Adjust image dimensions',
          gradient: 'gradient-blue',
          component: ImageResize
        },
        {
          id: 'image-rotate',
          icon: '🔄',
          title: 'Image Rotate',
          description: 'Rotate images 90°/180°/270°',
          gradient: 'gradient-pink',
          component: ImageRotate
        },
        {
          id: 'image-to-jpg',
          icon: '🖼️',
          title: 'Convert to JPG',
          description: 'Convert images to JPG format',
          gradient: 'gradient-orange',
          component: ImageToJPG
        },
        {
          id: 'image-to-pdf',
          icon: '📄',
          title: 'Image to PDF',
          description: 'Convert images to PDF files',
          gradient: 'gradient-purple',
          component: ImageToPDF
        }
      ]
    },
    {
      category: 'PDF Tools',
      items: [
        {
          id: 'pdf-merge',
          icon: '📑',
          title: 'PDF Merge',
          description: 'Merge multiple PDF files',
          gradient: 'gradient-blue',
          component: PDFMerge
        },
        {
          id: 'pdf-split',
          icon: '✂️',
          title: 'PDF Split',
          description: 'Split PDF into separate pages',
          gradient: 'gradient-pink',
          component: PDFSplit
        },
        {
          id: 'pdf-rotate',
          icon: '🔄',
          title: 'PDF Rotate',
          description: 'Rotate PDF pages',
          gradient: 'gradient-orange',
          component: PDFRotate
        }
      ]
    }
  ];

  const renderHomepage = () => (
    <div className="homepage">
      <header className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="gradient-text">Pixelo - Free Online Image & PDF Tools</span>
          </h1>
          <p className="hero-subtitle">
            Image compression, PDF processing - simple, fast, completely free
          </p>
          <div className="hero-features">
            <div className="feature">
              <span className="feature-icon">⚡</span>
              <span>Easy to Use</span>
            </div>
            <div className="feature">
              <span className="feature-icon">📦</span>
              <span>Batch Processing</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🔒</span>
              <span>Data Security</span>
            </div>
            <div className="feature">
              <span className="feature-icon">💯</span>
              <span>Completely Free</span>
            </div>
          </div>
        </div>
      </header>

      <main className="tools-section">
        {tools.map((category, idx) => (
          <div key={idx} className="tool-category">
            <h2 className="category-title">{category.category}</h2>
            <div className="tools-grid">
              {category.items.map((tool) => (
                <ToolCard
                  key={tool.id}
                  icon={tool.icon}
                  title={tool.title}
                  description={tool.description}
                  gradient={tool.gradient}
                  onClick={() => setCurrentTool(tool)}
                />
              ))}
            </div>
          </div>
        ))}
      </main>

      <footer className="footer">
        <div className="footer-content">
          <p>Making file processing simple</p>
          <p className="footer-note">All processing is done locally in your browser to protect your privacy</p>
          <div className="footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/terms">Terms of Service</Link>
            <span className="separator">|</span>
            <Link to="/about">About Us</Link>
            <span className="separator">|</span>
            <Link to="/contact">Contact</Link>
          </div>
          <p className="footer-copyright">© 2025 Pixelo</p>
        </div>
      </footer>
    </div>
  );

  const renderTool = () => {
    const ToolComponent = currentTool.component;
    return (
      <div className="tool-container">
        <button className="back-button" onClick={() => setCurrentTool(null)}>
          ← Back to Home
        </button>
        <ToolComponent />
      </div>
    );
  };

  return (
    <div className="App">
      {currentTool ? renderTool() : renderHomepage()}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
